import Toast from "./toast"

const Tools = {
    validate: (elements, message) => {
        let counter = 0
        elements.forEach(element => {
            if (element == null) {
                counter++
            }
            else {
                if (element instanceof Array) {
                    if (element.length == 0) {
                        counter++
                    }
                }
                else if (element instanceof String) {
                    if (element == undefined || element == null || element == "") {
                        counter++
                    }
                }
                else {
                    if (element == undefined || element == null) {
                        counter++
                    }
                }
            }
        })
        if (counter != 0) {
            Toast.error(message)
            throw new Error(message)

        }
    },
}

export default Tools